import { render, staticRenderFns } from "./sub-form-widget.vue?vue&type=template&id=40960421&scoped=true&"
import script from "./sub-form-widget.vue?vue&type=script&lang=js&"
export * from "./sub-form-widget.vue?vue&type=script&lang=js&"
import style0 from "./sub-form-widget.vue?vue&type=style&index=0&id=40960421&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40960421",
  null
  
)

export default component.exports